export const handleFaltas = (limiteFatlas, faltas) => {
    if (limiteFatlas === 0 || limiteFatlas == null) {
        return "0/0";
    } else {
        return `${faltas}/${limiteFatlas}`;
    }
}

export const handlePromedio = promedio => {
    let hidePromedio = false;

    if (promedio === null || promedio === "") {
        hidePromedio = true;
    }

    if (hidePromedio) {
        return null;
    } else {
        return promedio;
    }
}
